import { defineRecipe } from '@chakra-ui/react';

export const linkRecipe = defineRecipe({
  className: 'link',
  base: {
    color: 'teal.300',
    fontWeight: 'bold',
    textDecor: 'underline',
  },
});
